var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#43B02A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.30474 14.1357H22.3618C22.6786 14.1357 22.9355 14.4481 22.9355 14.8335C22.9355 15.2188 22.6786 15.5312 22.3618 15.5312H9.30474C8.98783 15.5312 8.73096 15.2188 8.73096 14.8335C8.73096 14.4481 8.98783 14.1357 9.30474 14.1357Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5503 14.8333L17.0597 9.37271C16.8356 9.10023 16.8356 8.65846 17.0597 8.38598C17.2837 8.11353 17.647 8.11353 17.8711 8.38598L22.7675 14.3399C22.9916 14.6124 22.9916 15.0542 22.7675 15.3267L17.8711 21.2806C17.7591 21.4169 17.6122 21.485 17.4654 21.485C17.3185 21.485 17.1717 21.4169 17.0596 21.2806C16.8355 21.0081 16.8355 20.5664 17.0596 20.2939L21.5503 14.8333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/sendMessage.0e3b8aaac4542909f94fe54c43eccb36.svg";
export { ForwardRef as ReactComponent };